import moment from 'moment';
import helpers from '../index.js';
import { VoucherCategory } from '../../vouchers/index.js';
export const money = (n) => n * 100;
export const calcCollectionCostGen = (selfCollectionCosts, foreignCollectionCosts) => (caseVouchers, documents, expirationSettings, selfCollection) => {
    const distributedVouchers = helpers.interest.calculate(caseVouchers, documents, expirationSettings, moment().format());
    const principalTotalAmount = Math.round(Math.max(0, -helpers.overview.balanceCategoryWithDistribution(distributedVouchers.filter((caseVoucher) => {
        return (new Date(caseVoucher.dueDate || caseVoucher.date).getTime() <
            new Date().getTime());
    }), VoucherCategory.PRINCIPAL)) / 100);
    const costs = selfCollection ? selfCollectionCosts : foreignCollectionCosts;
    for (let i = 0; i < costs.tiers.length; i++) {
        const tier = costs.tiers[i];
        if (tier.from > principalTotalAmount) {
            continue;
        }
        if (tier.to != null && tier.to < principalTotalAmount) {
            continue;
        }
        return tier.value(principalTotalAmount);
    }
    throw new Error('Nonexhaustive costsTable');
};
//# sourceMappingURL=common.js.map